module.exports = __webpack_public_path__ + "img/yibaotongqiantai.74d77693.png";